import { DetailConfig, DetailType, ISubjectFrontEndModel } from "./types";

export const SUBJECTS_LIST: ISubjectFrontEndModel[] = [
  {
    id: 1,
    name: "Biology",
    icon: "https://cdn.worlded.us/uploads/service-provider-logos/1690228247240-service-provider.jpg",
  },
  {
    id: 2,
    name: "Chemistry",
    icon: "https://cdn.worlded.us/uploads/service-provider-logos/1690228247240-service-provider.jpg",
  },
  {
    id: 3,
    name: "Math",
    icon: "https://cdn.worlded.us/uploads/service-provider-logos/1690228247240-service-provider.jpg",
  },
  {
    id: 4,
    name: "English",
    icon: "https://cdn.worlded.us/uploads/service-provider-logos/1690228247240-service-provider.jpg",
  },
  {
    id: 5,
    name: "German",
    icon: "https://cdn.worlded.us/uploads/service-provider-logos/1690228247240-service-provider.jpg",
  },
  {
    id: 6,
    name: "French",
    icon: "https://cdn.worlded.us/uploads/service-provider-logos/1690228247240-service-provider.jpg",
  },
  {
    id: 7,
    name: "Spanish",
    icon: "https://cdn.worlded.us/uploads/service-provider-logos/1690228247240-service-provider.jpg",
  },
  {
    id: 8,
    name: "Economy",
    icon: "https://cdn.worlded.us/uploads/service-provider-logos/1690228247240-service-provider.jpg",
  },
  {
    id: 9,
    name: "Business",
    icon: "https://cdn.worlded.us/uploads/service-provider-logos/1690228247240-service-provider.jpg",
  },
  {
    id: 10,
    name: "Computer Science",
    icon: "https://cdn.worlded.us/uploads/service-provider-logos/1690228247240-service-provider.jpg",
  },
  {
    id: 11,
    name: "Robotics",
    icon: "https://cdn.worlded.us/uploads/service-provider-logos/1690228247240-service-provider.jpg",
  },
  {
    id: 12,
    name: "Humanity",
    icon: "https://cdn.worlded.us/uploads/service-provider-logos/1690228247240-service-provider.jpg",
  },
  {
    id: 13,
    name: "History",
    icon: "https://cdn.worlded.us/uploads/service-provider-logos/1690228247240-service-provider.jpg",
  },
  {
    id: 14,
    name: "Geometry",
    icon: "https://cdn.worlded.us/uploads/service-provider-logos/1690228247240-service-provider.jpg",
  },
  {
    id: 15,
    name: "Geography",
    icon: "https://cdn.worlded.us/uploads/service-provider-logos/1690228247240-service-provider.jpg",
  },
  {
    id: 16,
    name: "Physics",
    icon: "https://cdn.worlded.us/uploads/service-provider-logos/1690228247240-service-provider.jpg",
  },
  {
    id: 17,
    name: "Gaming",
    icon: "https://cdn.worlded.us/uploads/service-provider-logos/1690228247240-service-provider.jpg",
  },
];

export const TEACHING_LEVEL = [
  {
    id: 1,
    name: "Elementary School",
  },
  {
    id: 2,
    name: "Middle School",
  },
  {
    id: 3,
    name: "High School",
  },
  {
    id: 4,
    name: "Bachelor",
  },
  {
    id: 5,
    name: "Master",
  },
];

export const teacherRegisterDetailsConfig: DetailConfig[] = [
  {
    type: DetailType.Bio,
    name: "Bio",
    isRequired: true,
  },
  {
    type: DetailType.Education,
    name: "Education",
    isRequired: true,
  },
  {
    type: DetailType.Experience,
    name: "Experience",
    isRequired: true,
  },
  {
    type: DetailType.SubjectDescription,
    name: "Subject Description",
    isRequired: false,
  },
  {
    type: DetailType.Calendar,
    name: "Calendar",
    isRequired: false,
  },
];
